import { EnrichedLot, LotPrice } from '../models/lot';

interface MockLotProps {
  locale: string;
  id: number;
  imageUrl?: string;
  lotUrl?: string;
  price?: string;
  closed?: boolean;
  lotPriceInCurrencies?: LotPrice | undefined;
}

const MockLotPrice: LotPrice = {
  auction_id: 12345,
  bidding_end_time: '',
  bidding_start_time: '',
  closed: false,
  current_bid_amount: {
    EUR: 80,
    GBP: 100,
    USD: 120,
  },
  favorite_count: 1,
  highest_bidder_token: '',
  id: 54321,
  realtime_channel: '',
  reserve_price_met: true,
};

export const MockLot = ({
  id,
  locale,
  imageUrl = '',
  price = '€10',
  closed = false,
  lotPriceInCurrencies = MockLotPrice,
}: MockLotProps): EnrichedLot => ({
  id,
  lotUrl: `https://www.catawiki.com/${locale}/l/${id}`,
  title: `Lot id - ${id}`,
  imageUrl,
  price,
  closed,
  lotPriceInCurrencies,
});

export const MockLots = [
  MockLot({
    locale: 'en',
    id: 57669673,
    imageUrl:
      'https://assets.catawiki.nl/assets/2022/4/5/5/a/0/5a0167a5-753d-41fd-8253-d721a5c41cc8.jpg',
    price: '￥2000',
    closed: false,
  }),
  MockLot({
    locale: 'en',
    id: 57670013,
    imageUrl:
      'https://assets.catawiki.nl/assets/2022/4/5/5/6/7/567ec72f-ca84-4927-a508-620fb199faa2.jpg',
    price: '￥4500',
    closed: false,
  }),
  MockLot({
    locale: 'en',
    id: 57778031,
    imageUrl:
      'https://assets.catawiki.nl/assets/2022/4/8/e/6/6/e662da9e-8991-446d-ad3b-52405151bef0.jpg',
    price: '￥3000',
    closed: false,
  }),
  MockLot({
    locale: 'en',
    id: 57786639,
    imageUrl:
      'https://assets.catawiki.nl/assets/2022/3/26/8/9/9/899ab4d6-0195-44ef-8e99-3afdc6657dc9.jpg',
    price: '￥5000',
    closed: false,
  }),
  MockLot({
    locale: 'en',
    id: 57849577,
    imageUrl:
      'https://assets.catawiki.nl/assets/2022/4/11/2/6/5/265324a2-ffe2-4653-b6f8-085ac9abe66a.jpg',
    price: '￥3300',
    closed: false,
  }),
  MockLot({
    locale: 'en',
    id: 57852453,
    imageUrl:
      'https://assets.catawiki.nl/assets/2022/4/11/6/3/1/63151fe6-f1ce-4bc4-98d4-6bc13105a5e9.jpg',
    price: '￥5500',
    closed: false,
  }),
  MockLot({
    locale: 'en',
    id: 57873067,
    imageUrl:
      'https://assets.catawiki.nl/assets/2021/12/2/7/a/a/7aaad37f-3356-4250-891a-a01bc281360d.jpg',
    price: '￥8900',
    closed: false,
  }),
];
